import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
// import { useNavigate } from "react-router-dom";
import { useUser } from "../context/UserContext";
import axios from 'axios';
import config from '../config';
import Layout from '../layout/Layout';
import Form from '../components/Form';
import PageLogo from '../components/PageLogo';
import PageTitle from '../components/PageTitle';
import FormField from '../components/FormField';
import ShowErrors from '../components/ShowErrors';
import ButtonSubmit from '../components/ButtonSubmit';
import LoginGoogle from '../components/LoginGoogle';
import LoginFacebook from '../components/LoginFacebook';
import { toast } from 'react-toastify';

const Login = ({ setCurrentPage }) => {
    // const navigate = useNavigate();
    const { user, setUser, loginUser, authService } = useUser();
    const [loading, setLoading] = useState(false);
    const [errors, setErrors] = useState([]);

    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name === 'email') {
            setErrors([]);
            setUser((prevUser) => ({
                ...prevUser,
                [name]: value.toLowerCase(),
            }));
        } else {
            setUser((prevUser) => ({
                ...prevUser,
                [name]: value,
            }));
        }
    };

    const handleBlur = (e) => {
        const { name, value } = e.target;

        setUser((prevUser) => ({
            ...prevUser,
            [name]: value.trim(),
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        setLoading(true);
        try {
            // console.log(user);
            const response = await axios.post(`${config.apiBaseUrl}/auth/login`, user, {
                withCredentials: true,  // must include this to allow fastAPI to create cookies
            });
            // const response = await authService.post(`/auth/login`, user);
            // const response = await authService.login(user);
            // console.log(response);
            if (response.status === 200) {
                // console.log('User login successfully');
                // console.log(response.data);
               
                loginUser(response.data);
                // navigate("/");
                setCurrentPage('home');
            }
        } catch (error) {
            console.log(error)
            toast.info("Login failed")
            // errors.push(error.response?.data?.detail[0]['msg'] ?? 'Login failed');
            // setErrors(errors);
        } finally {
            setLoading(false);
        }
    };

    return (
        <Layout>
            <Form handleSubmit={handleSubmit}>
                <PageLogo />
                <PageTitle pageTitle={"Login"} />

                <FormField
                    label={"Email"}
                    name={"email"}
                    type={"email"}
                    value={user.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required={true}
                    autoFocus={true}
                />

                <FormField
                    label={"Password"}
                    name={"password"}
                    type={"password"}
                    value={user.password}
                    autoComplete="current-password"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    required={true}
                />

                <ShowErrors errors={errors} />
                
                <ButtonSubmit 
                    loading={loading} 
                    labeling={'Logging in ...'} 
                    label={'Login'} 
                    disabled={loading || errors.length > 0}
                />

                <div className="mt-4 text-gray-200 text-center">
                    Forgot your password?{" "}
                    <button
                        key='forgotPassword'
                        onClick={() => setCurrentPage('forgotPassword')}
                        className="text-orange-300 hover:underline"
                    >
                        Please Reset
                    </button>
                </div>

                <div className="mt-4 text-gray-200 text-center">
                    Do not have an account yet?{" "}
                    <button
                        key='signup'
                        onClick={() => setCurrentPage('signup')}
                        className="text-orange-300 hover:underline"
                    >
                        Please Sign Up
                    </button>
                </div>

                <div className="border-t text-gray-200 my-4 text-center">
                    Or, login using below:
                </div>

                <div className='flex justify-center items-center'>
                    <LoginGoogle/>

                    <LoginFacebook
                        setLoading={setLoading}
                    />

                    <ToastContainer
                        position="bottom-right"
                        autoClose={4000}
                        draggable
                        hideProgressBar={true}
                    />
                </div>
            </Form>
        </Layout>
    );
};

export default Login;

